import {
  GET_ALL_SUPPLIERS_RESPONSE_SUCCESS,
  GET_ALL_SUPPLIERS,
  CREATE_SUPPLIER,
  UPDATE_SUPPLIER,
} from "./actionTypes"

export const getAllSuppliers = () => {
  return {
    type: GET_ALL_SUPPLIERS,
  }
}
export const getAllSuppliersResponseSuccess = payload => ({
  type: GET_ALL_SUPPLIERS_RESPONSE_SUCCESS,
  payload: payload,
})

// ------------------------------------- CREATE --------------------------------------------------------

export const createSupplier = (payload, history) => {
  return {
    type: CREATE_SUPPLIER,
    payload: payload,
    history,
  }
}
// ------------------------------------- EDIT --------------------------------------------------------

export const updateSupplier = (payload, history, redirectTo) => {
  return {
    type: UPDATE_SUPPLIER,
    payload: payload,
    history,
    redirectTo,
  }
}
